import {Injectable} from '@angular/core';
import {AbstractMessageListenerService} from "./abstract-message-listener.service";
import {MatDialog} from "@angular/material/dialog";
import {GameNextRoundDialogComponent} from "../game/dialogs/game-next-round-dialog/game-next-round-dialog.component";
import {isHost} from "../shared/util/window.util";


@Injectable({
  providedIn: 'root'
})
export class BeginningOfRoundMessageService extends AbstractMessageListenerService<never> {

  constructor(private dialog: MatDialog) {
    super('roundBegin');
  }

  public override process(): void {
    if (isHost()) {
      return;
    }
    this.dialog.open(GameNextRoundDialogComponent, {
      backdropClass: ['mat-app-background'],
      panelClass: ['fullscreen', 'animate__animated', 'animate__bounceInDown', 'animate__faster']
    });
  }
}
